import { render, staticRenderFns } from "./modal-upload-product-images.vue?vue&type=template&id=6f4d42f2&scoped=true&"
import script from "./modal-upload-product-images.vue?vue&type=script&lang=js&"
export * from "./modal-upload-product-images.vue?vue&type=script&lang=js&"
import style0 from "./modal-upload-product-images.vue?vue&type=style&index=0&id=6f4d42f2&lang=less&scoped=true&"
import style1 from "./modal-upload-product-images.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d42f2",
  null
  
)

export default component.exports